module.exports = __webpack_public_path__ + "img/img-2-2.6c2ccc64.webp";